import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL, categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">US Fans Spreadsheet</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 max-w-md">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.categories")}</h4>
            <ul className="mt-4 space-y-2">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {t(`cat.${c.id}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.resources")}</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t("footer.guide")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {t("footer.visitStore")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 max-w-xl">{t("footer.disclaimer")}</p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">© 2026 US Fans Spreadsheet. {t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
}